import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-brand-salles-of',
  templateUrl: './brand-salles-of.component.html',
  styleUrls: ['./brand-salles-of.component.css']
})
export class BrandSallesOfComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/brand-salles-of/brand-salles-of.component.ts